const state = () => ({
  email: '',
  registrationErrorMessage: '',
  password: '',
  newsletterAgreement: false,
  legalAgreement: false,
  registrationReferenceLink: '',
  registrationType: '',
  loading: false,
  registrationSource: 'kz'
});

const getters = {
  email(state) {
    return state.email;
  },
  registrationErrorMessage(state) {
    return state.registrationErrorMessage;
  },
  password(state) {
    return state.password;
  },
  registrationReferenceLink(state) {
    return state.registrationReferenceLink;
  },
  newsletterAgreement(state) {
    return state.newsletterAgreement;
  },
  legalAgreement(state) {
    return state.legalAgreement;
  },
  registrationType(state) {
    return state.registrationType;
  },
  loading(state) {
    return state.loading;
  },
  registrationSource(state) {
    return state.registrationSource;
  }
};

const mutations = {
  setEmail(state, payload) {
    state.email = payload;
  },
  setRegistrationErrorMessage(state, payload) {
    state.registrationErrorMessage = payload;
  },
  setPassword(state, payload) {
    state.password = payload;
  },
  setLegalAgreement(state, payload) {
    state.legalAgreement = payload;
  },
  setNewsletterAgreement(state, payload) {
    state.newsletterAgreement = payload;
  },
  setRegistrationReferenceLink(state, payload) {
    let path;
    if (payload.from === undefined) {
      state.registrationReferenceLink = payload.document?.referrer;
      return;
    } else {
      if (payload.from.indexOf('http') === -1) {
        path = window.location.origin + payload.from;
      } else {
        path = payload.from;
      }
    }

    const ignoredUrls = ['/login', '/registrace', '/registracia'];

    if (
      !ignoredUrls.filter(url => {
        return path.indexOf(url) !== -1;
      }).length
    ) {
      state.registrationReferenceLink = path;
    }
  },
  setRegistrationType(state, payload) {
    state.registrationType = payload;
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  setRegistrationSource(state, payload) {
    state.registrationSource = payload;
  },
  resetEmailErrors(state, payload) {
    state.registrationErrorMessage = payload;
  },
  reset(state) {
    state.email = '';
    state.registrationErrorMessage = '';
    state.password = '';
    state.newsletterAgreement = false;
    state.legalAgreement = false;
    state.registrationReferenceLink = '';
    state.registrationType = '';
    state.loading = false;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

export const registration = {
  state,
  getters,
  mutations,
  namespaced: true
};
